// Needs to match backend
export enum AssetSpecs {
  Gen2 = 'G2',
  Gen3 = 'G3'
}

enum FriendlyAssetSpecs {
  Gen2 = 'G2',
  Gen3 = 'G3',
  Unknown = 'Unknown'
}

export function getAssetSpecName(spec: AssetSpecs | undefined) {
  switch (spec) {
    case AssetSpecs.Gen2:
      return FriendlyAssetSpecs.Gen2
    case AssetSpecs.Gen3:
      return FriendlyAssetSpecs.Gen3
    case undefined:
      return FriendlyAssetSpecs.Unknown
  }
}